import Card from '../../../components/Card'
import Heading from '../../../components/Heading'
import React from 'react'
import { useAdmin } from '../../../contexts/AdminContext'
import { Payment } from '../../../types/Subscription'
import Icon from '../../../components/Icon'
import { faCcPaypal } from '@fortawesome/free-brands-svg-icons'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'
import Button from '../../../components/Button'
import AddPaymentMethod from './AddPaymentMethod'
import { Elements } from '@stripe/react-stripe-js'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './PaymentBox.module.css'
import ConfirmModal from '../../../components/ConfirmModal'
import { closeModal, openModal } from '../../../services/ModalService'
import { showToast } from '../../../services/ToastService'

const PaymentBox: React.FC = () => {
    const { service, stripe, paymentMethods, getPaymentMethods } = useAdmin()
    const { t } = useTranslation(['settings'])

    const showDeleteModal = (payment: Payment) => {
        openModal({
            heading: t('common.confirmation'),
            content: (
                <ConfirmModal
                    text={t('payment.deleteQuestion')}
                    onSubmit={() => deletePayment(payment)}
                    onAbort={() => closeModal()}
                />
            ),
        })
    }

    const deletePayment = (payment: Payment) => {
        service.deletePaymentMethod(payment.id).then((res) => {
            if (res.status === 204) {
                showToast(t('payment.paymentDeleted'))
                getPaymentMethods()
            }
        })
    }

    const createIntend = () => {
        service.createIntent().then((res) => {
            if (res.data.data?.intent?.client_secret) {
                openModal({
                    heading: t('payment.paymentInformation'),
                    content: (
                        <div className={cx(styles['modalContent'])}>
                            <Elements
                                stripe={stripe}
                                options={{
                                    clientSecret:
                                        res.data.data.intent.client_secret,
                                }}
                            >
                                <AddPaymentMethod />
                            </Elements>
                        </div>
                    ),
                })
            }
        })
    }

    return (
        <Card>
            <Heading level={3}>{t('payment.paymentInformation')}</Heading>
            <div className={cx(styles['paymentMethods'])}>
                {paymentMethods.map((p) => {
                    return (
                        <Card key={p.id}>
                            <div className={cx(styles['paymentBox'])}>
                                {p.type === 'paypal' && p.paypal && (
                                    <div
                                        className={cx(styles['paymentDetail'])}
                                    >
                                        <Icon icon={faCcPaypal} size={'2rem'} />
                                        <p
                                            className={cx(
                                                styles[
                                                    'paymentDetailsDescription'
                                                ]
                                            )}
                                        >
                                            {p.paypal.payer_email}
                                        </p>
                                    </div>
                                )}
                                {p.type === 'card' && p.card && (
                                    <div
                                        className={cx(styles['paymentDetail'])}
                                    >
                                        <Icon
                                            icon={faCreditCard}
                                            size={'2rem'}
                                        />
                                        <p
                                            className={cx(
                                                styles[
                                                    'paymentDetailsDescription'
                                                ]
                                            )}
                                        >
                                            {'**** **** **** ' + p.card.last4}
                                        </p>
                                    </div>
                                )}
                                <u
                                    className={'zr-cursor-pointer'}
                                    onClick={() => showDeleteModal(p)}
                                >
                                    {t('payment.delete')}
                                </u>
                            </div>
                        </Card>
                    )
                })}
                {paymentMethods.length === 0 && (
                    <Button
                        hierarchy={'secondary'}
                        text={t('payment.newPaymentMethod')}
                        fn={() => createIntend()}
                    />
                )}
            </div>
        </Card>
    )
}

export default PaymentBox
